import PropTypes from 'prop-types'

import SearchFilters, {searchFiltersButtonDesigns} from '@adv-mt/mt-search-filters'
import SearchSort, {searchSortButtonDesigns} from '@adv-mt/mt-search-sort'

import {SEARCH_HEADER_PLACES, SEARCH_HEADER_PLACES_DICTIONARY} from './config.js'

const SearchHeader = ({
  aggregations,
  filtersProps = {},
  hasSortBtn = false,
  linkFactory: LinkFactory,
  listingSectionId,
  pageName,
  place,
  search,
  totalResults
}) => {
  return (
    <div className="mt-SearchHeader">
      <SearchFilters
        aggregations={aggregations}
        design={searchFiltersButtonDesigns.HIGHLIGHTED}
        filtersProps={filtersProps}
        listingSectionId={listingSectionId}
        pageName={pageName}
        place={SEARCH_HEADER_PLACES_DICTIONARY[place]}
        search={search}
        totalResults={totalResults}
      />
      {hasSortBtn && (
        <SearchSort
          design={searchSortButtonDesigns.BASIC}
          linkFactory={LinkFactory}
          pageName={pageName}
          search={search}
          withSortOrderInfo
        />
      )}
    </div>
  )
}

SearchHeader.displayName = 'SearchHeader'

SearchHeader.propTypes = {
  aggregations: PropTypes.array,
  filtersProps: PropTypes.object,
  hasSortBtn: PropTypes.bool,
  linkFactory: PropTypes.func,
  listingSectionId: PropTypes.string,
  pageName: PropTypes.string,
  place: PropTypes.string,
  search: PropTypes.object.isRequired,
  totalResults: PropTypes.number
}

export {SEARCH_HEADER_PLACES as searchHeaderPlaces}

export default SearchHeader
